export default "__VITE_ASSET__DkD$U9Aa__"